import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import { Types } from '@leverege/api-attributes';
import { Selector } from '@leverege/ui-elements'

import { NumericInput, LabelGroup, Section, Flex } from '~/views';
import BaseAttributeEditor from './BaseAttributeEditor.jsx';
import { UpdaterSelector, UpdaterFactory } from '~/editors/updaters';

import style from './style.css'

export default class BooleanAttributeEditor extends React.Component {

  static propTypes = {
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props );
    this.changePath = BaseAttributeEditor.ChangePath.bind( this )
    this.onUpdaterChange = BaseAttributeEditor.OnUpdaterChange.bind( this )
    this.onSelectUpdater = this.onSelectUpdater.bind( this )
  }

  onSelectUpdater( updater ) {
    this.changePath( 'sim/updater', updater, false )
  }

  render() {
    const { attribute : attr, blueprint } = this.props
    if ( attr == null ) {
      return <div />
    }
    const iValue = attr.sim && attr.sim.initialValue;
    const uProps = { attribute : attr, blueprint, onChange : this.onUpdaterChange }
    const updater = UpdaterFactory.createEditor( attr.sim && attr.sim.updater, uProps );

    return (
      <div>
        <BaseAttributeEditor {...this.props} />
        <Section header="Display Values">
          <Flex variant="vSpace" justify="space-between" wrap="wrap">
            <LabelGroup>
              <label />
              <Link to={`/project/${blueprint.projectId}/blueprint/${blueprint.id}/translation`}>
                Go to Translation tab
                {' '}
                <i className="fa fa-external-link" />
              </Link>
            </LabelGroup>
          </Flex>
        </Section>

        <Section header="Threshold">
          <Flex variant="vSpace" justify="space-between" wrap="wrap">
            <Flex.Layout grow={1} shrink={0} basis="140px">

              <LabelGroup>
                <label>True Delay</label>
                <NumericInput hint="seconds" 
                  value={attr.threshold && attr.threshold.trueDelay}
                  min={0}
                  float
                  size={8}
                  onChange={( v, err ) => { this.changePath( 'threshold/trueDelay', v, err ) }} />
              </LabelGroup>
            </Flex.Layout>

            <Flex.Layout grow={1} shrink={0} basis="140px">
              <LabelGroup>
                <label>False Delay</label>
                <NumericInput hint="seconds" 
                  value={attr.threshold && attr.threshold.falseDelay}
                  min={0}
                  float
                  size={8}
                  onChange={( v, err ) => { this.changePath( 'threshold/falseDelay', v, err ) }} />
              </LabelGroup>
            </Flex.Layout>
          </Flex>
        </Section>

        <Section header="Simulation">
          <Flex variant="vSpace" direction="column" align="stretch">

            <LabelGroup>
              <label>Initial Value</label>
              <Selector
                nameKey="name"
                values={Types.Boolean.values()}
                value={iValue === true || iValue === false ? iValue : null}
                onChange={( value ) => { this.changePath( 'sim/initialValue', value.value, false ); }} />
            </LabelGroup>
            { UpdaterSelector.hasCreators( attr ) && 
            (
              <LabelGroup>
                <label>Update Every</label>
                <UpdaterSelector attribute={attr} updater={attr.sim && attr.sim.updater} onSelect={this.onSelectUpdater} />
              </LabelGroup>
            )}
            {updater}
          </Flex>
        </Section>
      </div>
    ) 
  }
}
